import { TextFieldProps } from '@forgeglobal/design-framework';
import { MaskitoOptions } from '@maskito/core';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { FieldRenderProps } from 'react-final-form';
import MaskedTextField from '../MaskedTextField';

const options: MaskitoOptions = {
  mask: [
    ...new Array(2).fill(/\d/),
    '/',
    ...new Array(2).fill(/\d/),
    '/',
    ...new Array(4).fill(/\d/),
  ],
};

const DateOfBirthTextField = (
  props: TextFieldProps<any>
): React.ReactElement<FieldRenderProps<any, HTMLInputElement>> => {
  return (
    <MaskedTextField
      {...props}
      placeholder="mm/dd/yyyy"
      endAdornment={<CalendarMonthIcon />}
      options={options}
    />
  );
};

export default DateOfBirthTextField;
